export default __webpack_public_path__ + "static/media/FICHA TÉCNICA- BATATA DOCE ARAPEY.242c130b.pdf";